import { render } from "./ActionsBar.vue?vue&type=template&id=81305088"
const script = {}

import "./ActionsBar.vue?vue&type=style&index=0&id=81305088&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__